import { createListFilters, IOption } from '../../../../../components'

export type FaturaAtendimentosFilters = {
  protocolo: string
  /** Nome do profissional (só na visão interna, sem `:idEmpresa`). */
  profissional: string
  status?: IOption<boolean>
  pendente?: IOption<boolean>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<FaturaAtendimentosFilters>(
  {
    protocolo: '',
    profissional: '',
    status: undefined,
    pendente: undefined,
  }
)
